import { gql } from 'apollo-angular';

export const GET_CUSTOM_REMINDERS = gql`
  query customReminders($filter: CustomReminderFilterInput) {
    customReminders(filter: $filter) {
      id
      title
      description
      targetType
      targetId
      channel
      priority
      reminderType
      dueAt
      startAt
      endAt
      reminderStatus
      status
    }
  }
`;
export const FETCH_CUSTOM_REMINDERS_PAGINATION = gql`
  query findAllCustomRemindersWithPagination(
    $filter: CustomReminderPaginationInput
  ) {
    findAllCustomRemindersWithPagination(filter: $filter) {
      reminders {
        id
        title
        description
        targetType
        targetId
        channel
        priority
        reminderType
        dueAt
        startAt
        endAt
        reminderStatus
        status
        createdAt
        updatedAt
        deletedAt
      }
      total
      skip
      limit
    }
  }
`;
export const CUSTOM_REMINDER_ID = gql`
  query customReminder($id: Int!) {
    customReminder(id: $id) {
      id
      title
      description
      targetType
      targetId
      channel
      priority
      reminderType
      dueAt
      startAt
      endAt
      reminderStatus
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
